export enum LpFeeStartDate {
  FundFirstCloseDate = 'FUND_FIRST_CLOSE_DATE',
  LpSpecificClosedFirstTime = 'LP_SPECIFIC_CLOSE_DATE',
  DateOfFirstFundInvestment = 'DATE_OF_FIRST_FUND_INVESTMENT',
}

export enum LpArrearsCalculation {
  BasedOnPeriodEndingAmount = 'BASED_ON_PERIOD_ENDING_AMOUNT',
}

export enum LpFeeType {
  RecurringPercentage = 'RECURRING_PERCENTAGE',
  OneOffFixed = 'ONE_OFF_FIXED',
}

export enum LpFeeCalculationBasis {
  CommittedCapital = 'COMMITTED_CAPITAL',
  NetCalledCapital = 'NET_CALLED_CAPITAL',
  TotalAcquisitionCost = 'TOTAL_ACQUISITION_COST',
  UnrealisedAssetCost = 'UNREALISED_ASSET_COST',
  Fixed = 'FIXED',
}

export enum FeeApportionmentBasis {
  OneNumberOfPeriods = 'ONE_NUMBER_OF_PERIODS',
  ActualActual = 'ACTUAL_ACTUAL',
}

export enum LpAccrualFrequency {
  QuarterlyAdvance = 'QUARTERLY_ADVANCE',
  MonthlyAdvance = 'MONTHLY_ADVANCE',
  BiannualyAdvance = 'BIANNUALY_ADVANCE',
  AnnuallyAdvance = 'ANNUALLY_ADVANCE',
  QuarterlyArrears = 'QUARTERLY_ARREARS',
  MonthlyArrears = 'MONTHLY_ARREARS',
  BiannualyArrears = 'BIANNUALY_ARREARS',
  AnnuallyArrears = 'ANNUALLY_ARREARS',
}

export enum LpFeeCommitmentStatus {
  InsideCommitment = 'INSIDE_COMMITMENT',
  OutsideCommitment = 'OUTSIDE_COMMITMENT',
}
